import JdEnterpriseTopUp from './jd-enterprise-top-up.vue'

export default JdEnterpriseTopUp
